import TabGroup from '@components/tab-group';

export default class MediaCarousel extends TabGroup {
    static id = 'media-carousel';
}
